import {
    Icon, IconButton, LinearProgress, Pagination, Paper,
    Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow,
    tableCellClasses,
    tabsClasses
} from "@mui/material";

import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { styled } from '@mui/material/styles';

import { useAuthContext } from "../../shered/contexts";
import { FerramentasDaListagem } from "../../shered/components";
import { Enviroment } from "../../shered/enviroments";
import { useDebounce } from "../../shered/hooks";
import { LayoutBaseDePagina } from "../../shered/layouts";
import { IDadosRetornoLista, IListagemLigas, LigaService, lstStatus } from "../../shered/services/api/liga/LigaService";
import { DialogMensagem, IDadosModal } from "../../shered/components/modal/DialogMensagem";
import CookieService from "../../shered/services/autenticacao/CookieService";
import { UtilidadeService } from "../../shered/services/api/utilidades/UtilidadesService";

export const ListagemDeLigasAdm: React.FC = () => {
    const { isAuthenticated, logout } = useAuthContext();
    const [searchParams, SetSearchParams] = useSearchParams();
    const { debounce } = useDebounce();
    const navigate = useNavigate();
    const user = CookieService.get("access_user");

    const [rows, setRows] = useState<IListagemLigas[]>([]);
    const [totalCount, setTotalCount] = useState(0);
    const [isLoading, setIsLoadig] = useState(true);
    const [isComissario, setIsComissario] = useState(true);
    const [redirecionar, setRedirecionar] = useState("0");
    const [showModalMensagem, setShowModalMensagem] = useState(false);
    const [dadosModal, setDadosModal] = useState<IDadosModal>({
        acao: false,
        label: "",
        tipo: "error",
        mensagem: "Sessão Expirada!",
        display: "none",
        titulo: "Atenção"
    });

    const busca = useMemo(() => {
        return searchParams.get("busca") || "";
    }, [searchParams]);

    const pagina = useMemo(() => {
        return Number(searchParams.get("pagina") || "1");
    }, [searchParams]);


    useEffect(() => {
        setIsLoadig(true);
        let codigoLiga = localStorage.getItem("@codigoLiga");

        debounce(() => {
            //    if (codigoLiga === "" || codigoLiga === null) {                
            LigaService.getAllPorUsuarioAdm()
                .then((result) => {
                    setIsLoadig(false);
                    const lst = result.data;
                    if (lst.dado.length) {
                        setRows(lst.dado);
                    }
                    setTotalCount(result.totalCount); //data.dado.totalRegistros);
                    //setIsComissario(lst.comissario)
                })
                .catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        logout();
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar("0");
                        return;
                    }                  
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response !== undefined && errors.response.status !== 404 ? errors.response.data.mensagem : "Não foi possível efetuar a exclusão. Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar("");
                });
            setIsLoadig(false);
        })

    }, [pagina, busca]);

    const handleDelete = (id: number) => {
        if (window.confirm("Realmente deseja apagar?")) {
            LigaService.deleteById(id)
                .then((result) => {
                    setRows(oldRows => [
                        ...oldRows.filter(oldRow => oldRow.codigo !== id),
                    ]);
                    setShowModalMensagem(true);
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "success",
                        mensagem: "Registro excluido com sucesso!",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar("0");
                }).catch((errors) => {
                    setShowModalMensagem(true);
                    if (errors.response.status === 401) {
                        logout();
                        setDadosModal({
                            acao: true,
                            label: "",
                            tipo: "info",
                            mensagem: "Sessão expirada!",
                            display: "none",
                            titulo: "Atenção"
                        });
                        setRedirecionar("/login");
                        return;
                    }
                    setDadosModal({
                        acao: true,
                        label: "",
                        tipo: "error",
                        mensagem: errors.response !== undefined ? errors.response.data.mensagem : "Não foi possível efetuar a exclusão. Favor entrar em contato com a TI",
                        display: "none",
                        titulo: "Atenção"
                    });
                    setRedirecionar("");
                });
        }
    }

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
            padding: "8px "
        },
        [`&.${tableCellClasses.footer}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        }
    }));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td': {
            border: 0,
        },
        '&:last-child th': {
            border: 0,
            padding: "16px 10px "
        },
    }));

    const toggleModalMensagem = () => {

        setShowModalMensagem(modalVisivel => !modalVisivel);
        if (redirecionar === "") {            
            redirecionar.length === 1 ? navigate(-1) : navigate(redirecionar);
        }
    }

    const handleRedirecionar = (codigo: number) =>{
        if (codigo > 0) {
            let adm = user.administrador === true;
            let valores = `${codigo}/${adm}`;
            let crypt = UtilidadeService.crypt(valores);
            navigate(`/usuario/liga/detalhe/${crypt}`);
        }
    }
    

    return (
        <LayoutBaseDePagina
            titulo="Listagem de ligas Administrador"
            barraDeFerramentas={<FerramentasDaListagem
                mostrarInputBusca={false}
                textoBotaoNovo="Nova"
                textoDaBusca={busca}
                
                aoClicarBotaoNovo={() => navigate('/usuario/liga/detalhe/nova')}
                aoMudarTextoDeBusca={texto => SetSearchParams({ busca: texto, pagina: "1" }, { replace: true })}

            />}
        >
            {showModalMensagem && <DialogMensagem dados={dadosModal} isModalVisible={showModalMensagem} onBackClickClose={toggleModalMensagem} />}
            <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: "auto" }}>
                <Table>
                    <TableHead>
                        <StyledTableRow>
                            <StyledTableCell width={70}>Ações</StyledTableCell>
                            <StyledTableCell width={50} align="center">Código</StyledTableCell>
                            <StyledTableCell>Nome</StyledTableCell>
                            {/* <StyledTableCell>Conferência</StyledTableCell> */}
                            <StyledTableCell width={50} align="center">Classificação</StyledTableCell>
                            <StyledTableCell>Franquia</StyledTableCell>
                            <StyledTableCell>Status</StyledTableCell>
                            <StyledTableCell>Data</StyledTableCell>
                            <StyledTableCell>Logo</StyledTableCell>
                        </StyledTableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map(row => (
                            <StyledTableRow key={row.codigo} >
                                {row.comissario_Usuario || user.administrador === true ? (
                                    <StyledTableCell>
                                        <IconButton size="small" onClick={() => handleDelete(row.codigo)}>
                                            <Icon>delete</Icon>
                                        </IconButton>
                                        <IconButton size="small" onClick={() => handleRedirecionar(row.codigo) }>
                                            <Icon>edit</Icon>
                                        </IconButton>
                                    </StyledTableCell>
                                ) : <StyledTableCell></StyledTableCell>}
                                <StyledTableCell align="center" sx={{ cursor: "pointer" }} onClick={() => { navigate(`/usuario/liga/${row.codigo}`); localStorage.setItem("@codigoLiga", UtilidadeService.crypt(row.codigo.toString())); }}>{row.codigo}</StyledTableCell>
                                <StyledTableCell sx={{ cursor: "pointer" }} onClick={() => { navigate(`/usuario/liga/${row.codigo}`); localStorage.setItem("@codigoLiga", UtilidadeService.crypt(row.codigo.toString())); }}>{row.nome}</StyledTableCell>
                                {/* <StyledTableCell sx={{ cursor: "pointer" }} onClick={() => {navigate(`/usuario/liga/${row.codigo}`); localStorage.setItem("@codigoLiga", row.codigo.toString());}}>{row.conferencia_Franquia}</StyledTableCell> */}
                                <StyledTableCell align="center" sx={{ cursor: "pointer" }} onClick={() => { navigate(`/usuario/liga/${row.codigo}`); localStorage.setItem("@codigoLiga", UtilidadeService.crypt(row.codigo.toString())); }}>{row.classificacao_Franquia === 0 ? "" : row.classificacao_Franquia}</StyledTableCell>
                                <StyledTableCell sx={{ cursor: "pointer" }} onClick={() => { navigate(`/usuario/liga/${row.codigo}`); localStorage.setItem("@codigoLiga", UtilidadeService.crypt(row.codigo.toString())); }}>{row.nome_Franquia}</StyledTableCell>
                                <StyledTableCell sx={{ cursor: "pointer" }} onClick={() => { navigate(`/usuario/liga/${row.codigo}`); localStorage.setItem("@codigoLiga", UtilidadeService.crypt(row.codigo.toString())); }}>{lstStatus.find(f => f.codigo === row.status)?.label}</StyledTableCell>
                                <StyledTableCell sx={{ cursor: "pointer" }} onClick={() => { navigate(`/usuario/liga/${row.codigo}`); localStorage.setItem("@codigoLiga", UtilidadeService.crypt(row.codigo.toString())); }}>{new Date(row.dtCriacao).toLocaleDateString("pt-Br")}</StyledTableCell>
                                <StyledTableCell sx={{ cursor: "pointer" }} onClick={() => { navigate(`/usuario/liga/${row.codigo}`); localStorage.setItem("@codigoLiga", UtilidadeService.crypt(row.codigo.toString())); }}><img src={row.caminho_Logo} alt={row.logo} width={40} height={40} /></StyledTableCell>
                            </StyledTableRow>
                        ))
                        }
                    </TableBody>
                    {totalCount === 0 && !isLoading && (
                        <caption>{Enviroment.LISTAGEM_VAZIA}</caption>
                    )}
                    <TableFooter>
                        {isLoading && (
                            <StyledTableRow>
                                <StyledTableCell colSpan={9}>
                                    <LinearProgress variant="indeterminate" />
                                </StyledTableCell>
                            </StyledTableRow>
                        )}
                        {(totalCount > 0 && totalCount > Enviroment.LIMITE_DE_LINHAS) && (
                            <StyledTableRow>
                                <StyledTableCell colSpan={9}>
                                    <Pagination
                                        page={pagina}
                                        count={Math.ceil(totalCount / Enviroment.LIMITE_DE_LINHAS)}
                                        onChange={(_, newPage) => SetSearchParams({ busca, pagina: newPage.toString() }, { replace: true })}
                                    />
                                </StyledTableCell>
                            </StyledTableRow>
                        )}
                    </TableFooter>
                </Table>
            </TableContainer>
        </LayoutBaseDePagina>
    );
};